import type { Card, Grid, DealTarget } from './game'

export interface GravityMove {
  card: Card
  fromRow: number // -1 = from deal target
  col: number
  toRow: number
}

export function computeGravityStep(grid: Grid, dealTarget: DealTarget): GravityMove[] {
  const moves: GravityMove[] = []

  for (let c = 0; c < 5; c++) {
    let lowestEmpty = -1
    for (let r = 4; r >= 0; r--) {
      if (grid[r][c] === null) {
        lowestEmpty = r
        break
      }
    }
    if (lowestEmpty === -1) continue

    let sourceRow = -1
    for (let r = lowestEmpty - 1; r >= 0; r--) {
      if (grid[r][c] !== null) {
        sourceRow = r
        break
      }
    }

    if (sourceRow !== -1) {
      moves.push({ card: grid[sourceRow][c]!, fromRow: sourceRow, col: c, toRow: lowestEmpty })
    } else if (dealTarget[c] !== null) {
      moves.push({ card: dealTarget[c]!, fromRow: -1, col: c, toRow: lowestEmpty })
    }
  }

  return moves
}

export function applyGravityStep(
  grid: Grid,
  dealTarget: DealTarget,
  moves: GravityMove[]
): { grid: Grid; dealTarget: DealTarget } {
  const newGrid = grid.map(r => [...r])
  const newDealTarget = [...dealTarget]
  for (const move of moves) {
    if (move.fromRow === -1) {
      newDealTarget[move.col] = null
    } else {
      newGrid[move.fromRow][move.col] = null
    }
    newGrid[move.toRow][move.col] = move.card
  }
  return { grid: newGrid, dealTarget: newDealTarget }
}

export function hasHoles(grid: Grid, dealTarget: DealTarget): boolean {
  for (let c = 0; c < 5; c++) {
    for (let r = 4; r >= 0; r--) {
      if (grid[r][c] === null) {
        for (let above = r - 1; above >= 0; above--) {
          if (grid[above][c] !== null) return true
        }
      }
    }
    if (dealTarget[c] !== null) {
      for (let r = 0; r < 5; r++) {
        if (grid[r][c] === null) return true
      }
    }
  }
  return false
}
